'use strict';
import * as $j_app$002edata$002e$002dApp$002dDocument$002dData$002dCredit$002dNote$0024$0024anon$00241 from "./app.data.-App-Document-Data-Credit-Note$$anon$1.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentDataCreditNote(number, issuer, recipient, issueDate, invoiceNumber, invoiceDate, lineItems, originOfGoods, documentaryCredit, currency, placeOfReceipt, placeOfLoading, placeOfDelivery, placeOfDischarge, incoterm, extraCredit, purchaseOrderReference, transportDocumentNumber) {
  this.EW = null;
  this.EV = null;
  this.EX = null;
  this.L5 = null;
  this.XA = null;
  this.Xz = null;
  this.L6 = null;
  this.L7 = null;
  this.L2 = null;
  this.L1 = null;
  this.Lb = null;
  this.La = null;
  this.L8 = null;
  this.L9 = null;
  this.L4 = null;
  this.L3 = null;
  this.Lc = null;
  this.Ld = null;
  this.EW = number;
  this.EV = issuer;
  this.EX = recipient;
  this.L5 = issueDate;
  this.XA = invoiceNumber;
  this.Xz = invoiceDate;
  this.L6 = lineItems;
  this.L7 = originOfGoods;
  this.L2 = documentaryCredit;
  this.L1 = currency;
  this.Lb = placeOfReceipt;
  this.La = placeOfLoading;
  this.L8 = placeOfDelivery;
  this.L9 = placeOfDischarge;
  this.L4 = incoterm;
  this.L3 = extraCredit;
  this.Lc = purchaseOrderReference;
  this.Ld = transportDocumentNumber;
}
export { $c_Lapp_data_AppDocumentDataCreditNote as $c_Lapp_data_AppDocumentDataCreditNote };
$p = $c_Lapp_data_AppDocumentDataCreditNote.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_AppDocumentDataCreditNote;
/** @constructor */
function $h_Lapp_data_AppDocumentDataCreditNote() {
}
export { $h_Lapp_data_AppDocumentDataCreditNote as $h_Lapp_data_AppDocumentDataCreditNote };
$h_Lapp_data_AppDocumentDataCreditNote.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppDocumentDataCreditNote)) {
    if ((this.EW === x$0.EW)) {
      var x = this.EV;
      var x$2 = x$0.EV;
      var $x_15 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_15 = false;
    }
    if ($x_15) {
      var x$3 = this.EX;
      var x$4 = x$0.EX;
      var $x_14 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_14 = false;
    }
    if ($x_14) {
      var x$5 = this.L5;
      var x$6 = x$0.L5;
      var $x_13 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_13 = false;
    }
    if (($x_13 && (this.XA === x$0.XA))) {
      var x$7 = this.Xz;
      var x$8 = x$0.Xz;
      var $x_12 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_12 = false;
    }
    if ($x_12) {
      var x$9 = this.L6;
      var x$10 = x$0.L6;
      var $x_11 = ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      var $x_11 = false;
    }
    if ($x_11) {
      var x$11 = this.L7;
      var x$12 = x$0.L7;
      var $x_10 = ((x$11 === null) ? (x$12 === null) : x$11.f(x$12));
    } else {
      var $x_10 = false;
    }
    if ($x_10) {
      var x$13 = this.L2;
      var x$14 = x$0.L2;
      var $x_9 = ((x$13 === null) ? (x$14 === null) : x$13.f(x$14));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$15 = this.L1;
      var x$16 = x$0.L1;
      var $x_8 = ((x$15 === null) ? (x$16 === null) : x$15.f(x$16));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$17 = this.Lb;
      var x$18 = x$0.Lb;
      var $x_7 = ((x$17 === null) ? (x$18 === null) : x$17.f(x$18));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$19 = this.La;
      var x$20 = x$0.La;
      var $x_6 = ((x$19 === null) ? (x$20 === null) : x$19.f(x$20));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$21 = this.L8;
      var x$22 = x$0.L8;
      var $x_5 = ((x$21 === null) ? (x$22 === null) : x$21.f(x$22));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$23 = this.L9;
      var x$24 = x$0.L9;
      var $x_4 = ((x$23 === null) ? (x$24 === null) : x$23.f(x$24));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$25 = this.L4;
      var x$26 = x$0.L4;
      var $x_3 = ((x$25 === null) ? (x$26 === null) : x$25.f(x$26));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$27 = this.L3;
      var x$28 = x$0.L3;
      var $x_2 = ((x$27 === null) ? (x$28 === null) : x$27.f(x$28));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$29 = this.Lc;
      var x$30 = x$0.Lc;
      var $x_1 = ((x$29 === null) ? (x$30 === null) : x$29.f(x$30));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$31 = this.Ld;
      var x$32 = x$0.Ld;
      return ((x$31 === null) ? (x$32 === null) : x$31.f(x$32));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 18;
});
$p.t = (function() {
  return "AppDocumentDataCreditNote";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.EW;
      break;
    }
    case 1: {
      return this.EV;
      break;
    }
    case 2: {
      return this.EX;
      break;
    }
    case 3: {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDate(this.L5);
      break;
    }
    case 4: {
      return this.XA;
      break;
    }
    case 5: {
      return this.Xz;
      break;
    }
    case 6: {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcats_data_NonEmptyVector(this.L6);
      break;
    }
    case 7: {
      return this.L7;
      break;
    }
    case 8: {
      return this.L2;
      break;
    }
    case 9: {
      return this.L1;
      break;
    }
    case 10: {
      return this.Lb;
      break;
    }
    case 11: {
      return this.La;
      break;
    }
    case 12: {
      return this.L8;
      break;
    }
    case 13: {
      return this.L9;
      break;
    }
    case 14: {
      return this.L4;
      break;
    }
    case 15: {
      return this.L3;
      break;
    }
    case 16: {
      return this.Lc;
      break;
    }
    case 17: {
      return this.Ld;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "number";
      break;
    }
    case 1: {
      return "issuer";
      break;
    }
    case 2: {
      return "recipient";
      break;
    }
    case 3: {
      return "issueDate";
      break;
    }
    case 4: {
      return "invoiceNumber";
      break;
    }
    case 5: {
      return "invoiceDate";
      break;
    }
    case 6: {
      return "lineItems";
      break;
    }
    case 7: {
      return "originOfGoods";
      break;
    }
    case 8: {
      return "documentaryCredit";
      break;
    }
    case 9: {
      return "currency";
      break;
    }
    case 10: {
      return "placeOfReceipt";
      break;
    }
    case 11: {
      return "placeOfLoading";
      break;
    }
    case 12: {
      return "placeOfDelivery";
      break;
    }
    case 13: {
      return "placeOfDischarge";
      break;
    }
    case 14: {
      return "incoterm";
      break;
    }
    case 15: {
      return "extraCredit";
      break;
    }
    case 16: {
      return "purchaseOrderReference";
      break;
    }
    case 17: {
      return "transportDocumentNumber";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.yy = (function() {
  return this.EW;
});
$p.Wh = (function() {
  return this.EV;
});
$p.bXL = (function() {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$();
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector0$();
  return new $j_app$002edata$002e$002dApp$002dDocument$002dData$002dCredit$002dNote$0024$0024anon$00241.$c_Lapp_data_AppDocumentDataCreditNote$$anon$1().bwM(this);
});
function $isArrayOf_Lapp_data_AppDocumentDataCreditNote(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iS)));
}
export { $isArrayOf_Lapp_data_AppDocumentDataCreditNote as $isArrayOf_Lapp_data_AppDocumentDataCreditNote };
var $d_Lapp_data_AppDocumentDataCreditNote = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentDataCreditNote, "app.data.AppDocumentDataCreditNote", ({
  iS: 1,
  ce: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_AppDocumentDataCreditNote as $d_Lapp_data_AppDocumentDataCreditNote };
//# sourceMappingURL=app.data.-App-Document-Data-Credit-Note.js.map
